// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3q2rJ","addWidgetButton":"Header_addWidgetButton__u1kgH","dashboardTabs":"Header_dashboardTabs__eH-zf","active":"Header_active__lyZUL"};